export default "__VITE_ASSET__3cc10b57__"